<template>
  <b-card no-body style="border:none;">
    <div class>
      <div>
        <b-row style="width: 100%;">
          <b-col></b-col>
          <b-col cols="8">
            <div class="text-center">
              <vue-countdown-timer
                @end_callback="endCallBack"
                :start-time="dateNow"
                :end-time="expireDate"
                :interval="1000"
                :end-text="''"
              >
                <template slot="countdown" slot-scope="scope">
                  <h1>
                    <strong>{{`${scope.props.minutes} : ${scope.props.seconds}`}}</strong>
                  </h1>
                </template>
              </vue-countdown-timer>
            </div>
            <b-input-group
              id="example-input-group-0"
              label
              label-for="example-input-0 "
              class="mt-3"
            >
              <label></label>
              <b-form-input
                autocomplete="off"
                :placeholder="$t('register.confirmCode')"
                class="form-control form-control-solid h-auto p-3"
                id="example-input-0"
                name="example-input-0"
                v-model="$v.form.code.$model"
                :state="validateState('code')"
                aria-describedby="input-1-live-feedback"
              ></b-form-input>

              <b-form-invalid-feedback id="input-0-live-feedback">Code is required.</b-form-invalid-feedback>
              <b-button
                v-if="reset"
                variant="outline-primary"
                class="ml-2 pl-3 pr-3"
                @click="resend"
              >
                <i class="fa fa-undo"></i>
              </b-button>
            </b-input-group>
          </b-col>

          <b-col></b-col>
        </b-row>
        <!--begin::Action-->
        <b-card-footer class="pl-3 pr-3 pb-0 pt-2 mt-3 bg-white">
          <div class="float-right">
            <button
              style="width:140px;padding:10px"
              v-on:click="$emit('back')"
              class="btn btn-outline-danger font-weight-bold font-size-3 mr-1"
            >{{ $t("actions.back") }}</button>
            <button
              style="min-width:140px;padding:10px"
              type="submit"
              ref="kt_login_signup_submit"
              class="btn btn-primary font-weight-bold my-3 font-size-3"
              @click.prevent="confirm"
            >{{$t('login.forgetConfirm')}}</button>
          </div>
        </b-card-footer>
        <!--end::Action-->
      </div>
      <!--end::Form-->
    </div>
    <!--end::Signup-->
  </b-card>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}

.r {
  width: 350px !important;
}
</style>

<script>
import { mapActions, mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import moment from "moment";
import { bus } from "@/main";

export default {
  mixins: [validationMixin],
  name: "Confirmaion",
  data() {
    return {
      date: Date.now(),
      dateNow: Date(Date.now()),
      form: {
        code: ""
      },
      reset: false,
      minutes: 60 * 2 * 1000
    };
  },
  validations: {
    form: {
      code: {
        required,
        minLength: minLength(3)
      }
    }
  },
  methods: {
    ...mapActions("auth", [
      "confirmation",
    ]),
    endCallBack() {
      this.reset = true;
    },
    resend() {
      this.resetForm();
      this.minutes = 60 * 2 * 1000;
      this.date = Date.now();
      this.$emit("resend");
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form.code = null;
    },

    confirm() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      const code = this.$v.form.code.$model;

      const submitButton = this.$refs["kt_login_signup_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      setTimeout(async () => {
        let res = await this.confirmation({
          code: code
        });
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        if (!res) {
          this.$toast.error(this.$t("error.already_success"));
          return;
        }
      }, 1000);
    }
  },

  computed: {
    expireDate() {
      return this.date + this.minutes;
    }
  }
};
</script>
